import { cva } from 'class-variance-authority';
import classnames from 'classnames';
import { MouseEvent, ReactNode } from 'react';

const ButtonVariants = cva('cursor-pointer flex flex-row gap-1 items-center rounded-lg border', {
  variants: {
    size: {
      small: 'px-2 h-6 text-small font-regular',
      medium: 'px-3 h-8 text-body2 font-regular',
      large: 'px-3 h-9 text-body2 font-regular'
    },
    type: {
      primary: 'bg-button-bg_primary text-button-text_primary border-button-bg_primary hover:bg_primary_hover',
      secondary: 'bg-button-bg_secondary text-button-text_secondary border-border_primary hover:bg-secondary_hover',
      tertiary: 'bg-button-bg_tertiary text-button-text_tertiary hover:bg-tertiary_hover',
      blue: 'bg-button-bg_blue text-button-text_primary border-button-bg_blue [&_svg]:fill-white [&_path]:fill-white hover:bg-blue_hover',
      transparent: 'text-primary bg-transparent border-transparent'
    }
  },
  defaultVariants: {
    size: 'medium',
    type: 'primary'
  }
});

interface ButtonProps {
  className?: string;
  text?: string;
  children?: ReactNode;
  disabled?: boolean;
  size?: 'small' | 'medium' | 'large';
  type?: 'primary' | 'secondary' | 'tertiary' | 'blue' | 'transparent';
  htmlType?: 'button' | 'submit' | 'reset';
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
  icon?: ReactNode;
}

const Button = ({
  className = '',
  text,
  children,
  disabled = false,
  size = 'medium',
  type = 'primary',
  htmlType = 'button',
  onClick,
  icon
}: ButtonProps) => {
  const content = text || children;

  return (
    <button
      type={htmlType}
      className={classnames(ButtonVariants({ size, type, className }), {
        'cursor-not-allowed opacity-button_disabled': disabled
      })}
      onClick={onClick}
      disabled={disabled}
    >
      {icon && icon}
      {content && <span className="select-none text-nowrap">{content}</span>}
    </button>
  );
};

export default Button;